module.exports = __webpack_public_path__ + "img/alcoholic-beverages-beverage-celebration-2105511.6841435e.jpg";